import { Toast } from "primereact/toast";
import { useRef } from "react";
import { Table } from "./Table";

export const TrainingRatingForm = () => {
    const toast = useRef<any>(null);
    return (
        <>
            <Table toast={toast} reload={false} />
            <Toast ref={toast} />
        </>
    );
}